import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "source"],
  _excluded2 = ["course"];
import { useState } from "react";
import { useDisclosure } from "@crehana/react-hooks";
import CoursePreview from "../../components/CoursePreview";
import { CoursePreviewContext } from "./CoursePreviewContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CoursePreviewProvider = function CoursePreviewProvider(_ref) {
  var children = _ref.children,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? '' : _ref$source,
    coursePreviewProviderProps = _objectWithoutProperties(_ref, _excluded);
  var _useDisclosure = useDisclosure(false),
    coursePreviewIsOpen = _useDisclosure.isOpen,
    onOpen = _useDisclosure.onOpen,
    onClose = _useDisclosure.onClose;
  var _useState = useState(_objectSpread(_objectSpread({}, coursePreviewProviderProps), {}, {
      source: source
    })),
    _useState2 = _slicedToArray(_useState, 2),
    coursePreviewProps = _useState2[0],
    setCoursePreviewProps = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    currentCourse = _useState4[0],
    setCurrentCourse = _useState4[1];
  var openCoursePreview = function openCoursePreview(_ref2) {
    var course = _ref2.course,
      customCoursePreviewProps = _objectWithoutProperties(_ref2, _excluded2);
    setCurrentCourse(course);
    if (customCoursePreviewProps) {
      setCoursePreviewProps(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), customCoursePreviewProps);
      });
    }
    if (course !== null && course !== void 0 && course.originalId) {
      onOpen();
    }
  };
  var closeCoursePreview = function closeCoursePreview() {
    setCurrentCourse(undefined);
    onClose();
  };
  return /*#__PURE__*/_jsxs(CoursePreviewContext.Provider, {
    value: {
      currentCourse: currentCourse,
      coursePreviewIsOpen: coursePreviewIsOpen,
      openCoursePreview: openCoursePreview,
      closeCoursePreview: closeCoursePreview
    },
    children: [children, coursePreviewIsOpen && currentCourse ? /*#__PURE__*/_jsx(CoursePreview, _objectSpread({
      isOpen: coursePreviewIsOpen,
      onDismiss: closeCoursePreview,
      course: currentCourse
    }, coursePreviewProps)) : null]
  });
};
export default CoursePreviewProvider;